export interface AppPageLink {
  href: string;
  title: string;
}

// Centre and specialty links carried over from the previous PHP /app page, which
// earns ~12.6k Google visits a month; dropping them would drop its internal links.

export const TOP_CENTERS: AppPageLink[] = [
  { href: '/کلینیک-بیمارستان-نیکان', title: 'بیمارستان نیکان' },
  { href: '/بیمارستان-پوست-رازی-0', title: 'بیمارستان رازی' },
  { href: '/بیمارستان-حضرت-رسول-اکرم(ص)', title: 'بیمارستان رسول اکرم' },
  { href: '/بیمارستان-امام-رضا(ع)-مشهد', title: 'بیمارستان امام رضا' },
  { href: '/بیمارستان-فارابی-تهران-0', title: 'بیمارستان فارابی' },
  { href: '/آزمایشگاه-مرکز-بهداشت-بندرعباس', title: 'نوبت دهی تست کرونا بندرعباس' },
  { href: '/بیمارستان-تخصصی-و-فوق-تخصصی-تریتا', title: 'بیمارستان تریتا' },
  { href: '/بیمارستان-نیکان-غرب-تهران-0', title: 'بیمارستان نیکان غرب' },
  { href: '/بیمارستان-تخصصی-و-فوق-تخصصی-بهمن', title: 'بیمارستان بهمن' },
  { href: '/بیمارستان-شریعتی-تهران', title: 'بیمارستان شریعتی' },
  { href: '/بیمارستان-سینا', title: 'بیمارستان سینا' },
  { href: '/بیمارستان-عرفان-نیایش', title: 'بیمارستان عرفان نیایش' },
  { href: '/کلینیک-تخصصی-و-فوق-تخصصی-صاحب-کوثر', title: 'درمانگاه قوامین تهرانسر' },
  { href: '/بیمارستان-فوق-تخصصی-شهید-هاشمی-نژاد-تهران', title: 'بیمارستان هاشمی نژاد' },
  { href: '/بیمارستان-تخصصی-و-فوق-تخصصی-محب-کوثر', title: 'بیمارستان محب کوثر' },
  { href: '/بیمارستان-مرکز-قلب-تهران', title: 'بیمارستان قلب تهران' },
  { href: '/بیمارستان-فوق-تخصصی-چشم-پزشکی-نگاه', title: 'بیمارستان نگاه' },
  { href: '/مجتمع-بیمارستان-یاس', title: 'بیمارستان محب یاس' },
];

export const TOP_SPECIALTIES: AppPageLink[] = [
  { href: '/s/ir/anesthesia-and-intensive-care/', title: 'پزشک بیهوشی و مراقبت های ویژه' },
  { href: '/s/ir/orthopedics/', title: 'پزشک استخوان و مفاصل' },
  { href: '/s/ir/oncology/', title: 'پزشک خون و سرطان' },
  { href: '/s/ir/laboratory-and-imaging/', title: 'پزشک آزمایشگاه' },
  { href: '/s/ir/pulmonology/', title: 'پزشک ریه و دستگاه تنفسی' },
  { href: '/s/ir/urology/', title: 'پزشک کلیه و مجاری ادراری' },
  { href: '/s/ir/general-practitioner/', title: 'پزشک عمومی' },
  { href: '/s/ir/nutrition/', title: 'پزشک تغذیه' },
  { href: '/s/ir/dermatology/', title: 'پزشک پوست و مو' },
  { href: '/s/ir/surgery/', title: 'پزشک جراحی' },
  { href: '/s/ir/ophthalmology/', title: 'پزشک چشم پزشکی' },
  { href: '/s/ir/gastroenterology/', title: 'پزشک گوارش و معده' },
  { href: '/s/ir/dental-oral/', title: 'پزشک دهان و دندان' },
  { href: '/s/ir/psychology/', title: 'پزشک روانشناسی' },
  { href: '/s/ir/obstetrics-gynecology/', title: 'پزشک زنان، زایمان و نازایی' },
  { href: '/s/ir/genetics/', title: 'پزشک ژنتیک' },
  { href: '/s/ir/emergency-medicine/', title: 'پزشک طب اورژانس' },
  { href: '/s/ir/palliative-care/', title: 'پزشک طب تسکینی و درد' },
  { href: '/s/ir/infectious/', title: 'پزشک عفونی' },
  { href: '/s/ir/endocrinology/', title: 'پزشک غدد و متابولیسم' },
  { href: '/s/ir/cardiovascular/', title: 'پزشک قلب و عروق' },
  { href: '/s/ir/pediatrics/', title: 'پزشک اطفال، کودکان و نوزادان' },
  { href: '/s/ir/otorhinolaryngology/', title: 'پزشک گوش، حلق و بینی' },
  { href: '/s/ir/neurology/', title: 'پزشک مغز و اعصاب' },
  { href: '/s/ir/traditional-medicine/', title: 'پزشک طب سنتی' },
  { href: '/s/ir/rehabilitation/', title: 'پزشک توانبخشی' },
  { href: '/s/ir/internal/', title: 'پزشک داخلی' },
  { href: '/s/ir/corona-virus/', title: 'پزشک کرونا ویروس' },
  { href: '/s/ir/pharmacology/', title: 'پزشک داروسازی' },
  { href: '/s/ir/psychiatry/', title: 'پزشک روانپزشکی' },
  { href: '/s/ir/sexual-health/', title: 'پزشک سلامت جنسی' },
  { href: '/s/ir/beauty/', title: 'پزشک زیبایی' },
  { href: '/s/ir/allergies/', title: 'پزشک آلرژی' },
  { href: '/s/ir/diabetes/', title: 'پزشک دیابت' },
  { href: '/s/ir/imaging/', title: 'پزشک تصویربرداری' },
];
